import { useTranslation } from 'react-i18next';

import { Audience } from '@/services/AudiencesService';

interface SimilarityScoreProps {
  audience: Pick<Audience, 'similarity_score'>;
}

export function SimilarityScore({ audience }: SimilarityScoreProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Behaviors.AudiencesCreate.components.SimilarityScore',
  });

  return (
    <div>
      <div className="flex flex-row justify-between gap-2">
        <p className="text-sm text-gray-600">{t('title')}</p>
        <div className="text-w-10 flex flex-row items-center gap-2 font-semibold">
          {Number(audience?.similarity_score ?? 0) * 100}
        </div>
      </div>
    </div>
  );
}
